import React from 'react';
import './index.css';

type TextInputProps = {
    className?: string;
    id?: string;
    name?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    label?: string;
    placeholder?: string;
    required?: boolean;
    type?: React.HTMLInputTypeAttribute;
    value?: string | number | readonly string[];
    disabled?: boolean;
};

function TextInput({
    className,
    id,
    name,
    onChange,
    label,
    placeholder,
    required,
    type,
    value,
    disabled
}: TextInputProps) {
    return (
        <div className={`textInput ${className}`}>
            {label && <p className='textInput__label'>{label} {required && '*'}</p>}
            <input
                className='textInput__input'
                id={id}
                name={name}
                onChange={onChange}
                placeholder={placeholder}
                required={required}
                type={type}
                value={value}
                disabled={disabled}
            />
        </div>
    );
}

export default TextInput;